import { AbstractControl, AsyncValidatorFn, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { Observable, of, timer } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { PhoneNumberCheckResult } from '../../core/model';
import { AddressFacade } from '../../core/user';

export abstract class PhoneNumberValidator {
  public static phoneNumber(addressService: AddressFacade, errorKey = 'phoneNumber'): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (this.isFormGroup(control)) {
        throw new Error('Phone number validator must attach to form control');
      }
      if (!this.isValid(control)) {
        return of(null);
      }

      return this.getValidator(addressService, control.value).pipe(
        map((check: PhoneNumberCheckResult) => {
          return check.valid ? null : { [errorKey]: check };
        })
      );
    };
  }

  private static isFormGroup(control: AbstractControl): control is UntypedFormGroup {
    return Boolean((control as UntypedFormGroup).controls);
  }

  private static isValid(control: AbstractControl): boolean {
    return control && !!control.value;
  }

  private static getValidator(service: AddressFacade, phoneNumber: string): Observable<PhoneNumberCheckResult> {
    return timer(500) // no spamming allowed
      .pipe(
        switchMap(() => service.validatePhoneNumber(phoneNumber)),
        take(1)
      );
  }
}
